import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M12 20.752a8.75 8.75 0 1 1 0-17.5 8.75 8.75 0 0 1 0 17.5Zm0 1.25c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M10.75 16.377c0-.345.28-.625.625-.625h1.25a.625.625 0 1 1 0 1.25h-1.25a.625.625 0 0 1-.625-.625ZM8.25 12.627c0-.345.28-.625.625-.625h6.25a.625.625 0 1 1 0 1.25h-6.25a.625.625 0 0 1-.625-.625ZM5.75 8.877c0-.345.28-.625.625-.625h11.25a.625.625 0 1 1 0 1.25H6.375a.625.625 0 0 1-.625-.625Z"
    }, null, -1)
  ]))]))
}
export default { render: render }